/* ==========================================================================
   ZORA — Header runtime
   Announcement rotator · mega menu · localization · mobile drawer ·
   intelligent predictive search
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.ZoraSearchConfig || {};
  var L = cfg.labels || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) {
    return (r || document).querySelector(s);
  }
  function $$(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }
  function on(el, e, fn, o) {
    el && el.addEventListener(e, fn, o);
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ======================================================================
     1. Announcement rotator
     ====================================================================== */
  (function () {
    var root = $('[data-z-annc]');
    if (!root) return;

    var slides = $$('[data-z-annc-slide]', root);
    if (slides.length < 2) return;

    var index = 0;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var timer;

    function go(next) {
      if (next === index) return;
      var from = slides[index];
      var to = slides[next];
      from.classList.add('is-leaving');
      from.classList.remove('is-active');
      to.classList.remove('is-leaving');
      void to.offsetWidth;
      to.classList.add('is-active');
      setTimeout(function () {
        from.classList.remove('is-leaving');
      }, 520);
      index = next;
    }

    function step(dir) {
      go((index + dir + slides.length) % slides.length);
    }
    function start() {
      if (reduceMotion) return;
      stop();
      timer = setInterval(function () {
        step(1);
      }, speed);
    }
    function stop() {
      clearInterval(timer);
    }

    on($('[data-z-annc-next]', root), 'click', function () {
      step(1);
      start();
    });
    on($('[data-z-annc-prev]', root), 'click', function () {
      step(-1);
      start();
    });
    on(root, 'mouseenter', stop);
    on(root, 'mouseleave', start);
    on(document, 'visibilitychange', function () {
      document.hidden ? stop() : start();
    });

    start();
  })();

  /* ======================================================================
     2. Mega menu
     ====================================================================== */
  var closeAllMegas = function () {};

  (function () {
    var parents = $$('[data-z-mega-parent]');
    if (!parents.length) return;

    var header = $('[data-z-header]');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var closeTimer;

    function close(item) {
      item.classList.remove('is-open');
      var link = $('.z-nav__link', item);
      if (link) link.setAttribute('aria-expanded', 'false');
    }

    function closeAll() {
      parents.forEach(close);
      if (header) header.classList.remove('is-mega-open');
    }
    closeAllMegas = closeAll;

    function open(item) {
      parents.forEach(function (other) {
        if (other !== item) close(other);
      });
      item.classList.add('is-open');
      if (header) header.classList.add('is-mega-open');
      var link = $('.z-nav__link', item);
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    parents.forEach(function (item) {
      var link = $('.z-nav__link', item);
      var closeBtn = $('[data-z-mega-close]', item);

      if (canHover) {
        on(item, 'mouseenter', function () {
          clearTimeout(closeTimer);
          open(item);
        });
        on(item, 'mouseleave', function () {
          closeTimer = setTimeout(closeAll, 140);
        });
      }

      on(link, 'click', function (e) {
        // On touch, the first tap reveals the panel instead of navigating
        if (!canHover && !item.classList.contains('is-open')) {
          e.preventDefault();
          open(item);
        }
      });

      on(closeBtn, 'click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        close(item);
        if (header) header.classList.remove('is-mega-open');
        if (link) link.focus();
      });

      on(item, 'focusin', function () {
        open(item);
      });
      on(item, 'focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();

  /* ======================================================================
     3. Localization dropdown
     ====================================================================== */
  (function () {
    var root = $('[data-z-locale]');
    if (!root) return;

    var toggle = $('[data-z-locale-toggle]', root);
    var panel = $('[data-z-locale-panel]', root);
    if (!toggle || !panel) return;

    function setOpen(open) {
      root.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.toggleAttribute('hidden', !open);
    }

    on(toggle, 'click', function (e) {
      e.stopPropagation();
      setOpen(panel.hasAttribute('hidden'));
    });

    on(document, 'click', function (e) {
      if (!root.contains(e.target)) setOpen(false);
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  })();

  /* ======================================================================
     4. Mobile drawer
     ====================================================================== */
  (function () {
    var root = $('[data-z-drawer]');
    if (!root) return;

    var panel = $('.z-drawer__panel', root);
    var rootList = $('[data-z-drawer-level="1"]', root);
    var lastTrigger = null;

    function openDrawer(trigger) {
      lastTrigger = trigger;
      root.removeAttribute('hidden');
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.body.classList.add('z-locked');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        var first = $('.z-drawer__link', root);
        if (first) first.focus();
      }, 320);
    }

    function closeDrawer() {
      root.classList.remove('is-open');
      document.body.classList.remove('z-locked');
      setTimeout(function () {
        root.setAttribute('hidden', '');
        $$('[data-z-drawer-panel]', root).forEach(function (p) {
          p.classList.remove('is-open');
          p.setAttribute('hidden', '');
        });
        if (rootList) rootList.classList.remove('is-pushed');
      }, 420);
      if (lastTrigger) {
        lastTrigger.setAttribute('aria-expanded', 'false');
        lastTrigger.focus();
      }
    }

    $$('[data-z-drawer-open]').forEach(function (btn) {
      on(btn, 'click', function () {
        openDrawer(btn);
      });
    });
    $$('[data-z-drawer-close]', root).forEach(function (btn) {
      on(btn, 'click', closeDrawer);
    });

    $$('[data-z-drawer-next]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var target = $('[data-z-drawer-panel="' + btn.getAttribute('data-z-drawer-next') + '"]', root);
        if (!target) return;
        target.removeAttribute('hidden');
        requestAnimationFrame(function () {
          target.classList.add('is-open');
          if (rootList) rootList.classList.add('is-pushed');
        });
        setTimeout(function () {
          var back = $('.z-drawer__back', target);
          if (back) back.focus();
        }, 300);
      });
    });

    $$('[data-z-drawer-back]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var target = btn.closest('[data-z-drawer-panel]');
        target.classList.remove('is-open');
        if (rootList) rootList.classList.remove('is-pushed');
        setTimeout(function () {
          target.setAttribute('hidden', '');
        }, 420);
      });
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
    });

    on(panel, 'keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = $$('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])', panel).filter(
        function (el) {
          return el.offsetParent !== null;
        }
      );
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  })();

  /* ======================================================================
     5. Cart drawer trigger (Dawn interop)
     ====================================================================== */
  $$('[data-z-cart-open]').forEach(function (link) {
    on(link, 'click', function (e) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || cartDrawer.classList.contains('is-empty')) return;
      e.preventDefault();
      if (typeof cartDrawer.open === 'function') cartDrawer.open(link);
      else cartDrawer.classList.add('animate', 'active');
    });
  });

  /* ======================================================================
     6. Rotating search keywords
     ====================================================================== */
  (function () {
    var rotator = $('[data-z-rotator]');
    if (!rotator || reduceMotion) return;

    var words = $$('.z-searchbox__word', rotator);
    if (words.length < 2) return;

    var i = 0;
    setInterval(function () {
      var from = words[i];
      var next = (i + 1) % words.length;
      var to = words[next];
      from.classList.remove('is-active');
      from.classList.add('is-leaving');
      to.classList.remove('is-leaving');
      void to.offsetWidth;
      to.classList.add('is-active');
      setTimeout(function () {
        from.classList.remove('is-leaving');
      }, 420);
      i = next;
    }, cfg.rotateSpeed || 2400);
  })();

  /* ======================================================================
     7. Semantic expansion + recent searches
     ====================================================================== */
  var semantic = (function () {
    var map = {};
    (cfg.semanticMap || '').split(/\n+/).forEach(function (line) {
      var parts = line.split('=');
      if (parts.length < 2) return;
      var key = parts[0].trim().toLowerCase();
      if (!key) return;
      map[key] = parts[1]
        .split(',')
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);
    });
    return map;
  })();

  function expandQuery(query) {
    var q = query.toLowerCase().trim();
    if (!q) return [];
    var out = [];
    Object.keys(semantic).forEach(function (key) {
      if (q.indexOf(key) !== -1) {
        semantic[key].forEach(function (term) {
          if (out.indexOf(term) === -1) out.push(term);
        });
      }
    });
    return out.slice(0, 5);
  }

  var RECENT_KEY = 'zora:searches:v1';

  function readRecent() {
    try {
      var raw = localStorage.getItem(RECENT_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function pushRecent(term) {
    term = (term || '').trim();
    if (term.length < 2) return;
    var list = readRecent().filter(function (t) {
      return t.toLowerCase() !== term.toLowerCase();
    });
    list.unshift(term);
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }

  /* ======================================================================
     8. Predictive search
     ====================================================================== */
  (function () {
    var panel = $('[data-z-search]');
    if (!panel) return;

    var header = $('[data-z-header]');
    var scrim = $('[data-z-search-scrim]');
    var form = $('[data-z-search-form]');
    var input = $('[data-z-search-input]');
    var ghost = $('[data-z-search-ghost]');
    var clearBtn = $('[data-z-search-clear]');

    var mobileForm = $('[data-z-search-form-mobile]');
    var mobileInput = $('[data-z-search-input-mobile]');

    var idle = $('[data-z-search-idle]', panel);
    var live = $('[data-z-search-live]', panel);
    var loading = $('[data-z-search-loading]', panel);
    var recentWrap = $('[data-z-search-recent]', panel);
    var recentList = $('[data-z-search-recent-list]', panel);
    var openBtns = $$('[data-z-search-open]');
    var closeBtn = $('[data-z-search-close]', panel);

    var isOpen = false;
    var controller = null;
    var debounceTimer = null;
    var cache = {};
    var activeIndex = -1;

    function activeInput() {
      return mobileInput && mobileInput.offsetParent !== null ? mobileInput : input;
    }

    /* ---------------- open / close ---------------- */
    function openPanel(focusTarget) {
      if (isOpen) return;
      isOpen = true;
      closeAllMegas();
      panel.removeAttribute('hidden');
      if (scrim) scrim.removeAttribute('hidden');
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        if (scrim) scrim.classList.add('is-open');
      });
      if (header) header.classList.add('is-search-open');
      openBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
      if (input) input.setAttribute('aria-expanded', 'true');
      renderRecent();
      if (focusTarget) {
        setTimeout(function () {
          focusTarget.focus();
        }, 120);
      }
    }

    function closePanel() {
      if (!isOpen) return;
      isOpen = false;
      panel.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      setTimeout(function () {
        panel.setAttribute('hidden', '');
        if (scrim) scrim.setAttribute('hidden', '');
      }, 360);
      if (header) header.classList.remove('is-search-open');
      openBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (input) input.setAttribute('aria-expanded', 'false');
    }

    // Desktop: focusing the inline field opens the panel
    on(input, 'focus', function () {
      openPanel(null);
    });
    on(input, 'click', function () {
      openPanel(null);
    });

    // Mobile: the icon opens the panel and focuses its own field
    openBtns.forEach(function (btn) {
      on(btn, 'click', function () {
        if (isOpen) {
          closePanel();
        } else {
          openPanel(mobileInput || input);
        }
      });
    });

    on(closeBtn, 'click', closePanel);
    on(scrim, 'click', closePanel);

    // Click outside the header closes it
    on(document, 'click', function (e) {
      if (!isOpen) return;
      if (panel.contains(e.target)) return;
      if (form && form.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-z-search-open]')) return;
      closePanel();
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        e.preventDefault();
        closePanel();
        var ai = activeInput();
        if (ai) ai.blur();
        return;
      }
      // "/" jumps to search, the way docs sites do
      if (e.key === '/' && !isOpen) {
        var tag = (document.activeElement.tagName || '').toLowerCase();
        if (tag === 'input' || tag === 'textarea' || document.activeElement.isContentEditable) return;
        e.preventDefault();
        openPanel(input || mobileInput);
      }
    });

    /* ---------------- ghost placeholder ---------------- */
    function syncGhost() {
      if (!input) return;
      var has = input.value.length > 0;
      if (ghost) ghost.toggleAttribute('hidden', has);
      if (clearBtn) clearBtn.toggleAttribute('hidden', !has);
    }

    on(clearBtn, 'click', function () {
      input.value = '';
      syncGhost();
      showIdle();
      input.focus();
    });

    /* ---------------- recent chips ---------------- */
    function renderRecent() {
      if (!recentWrap || !recentList) return;
      var list = readRecent();
      if (!list.length) {
        recentWrap.setAttribute('hidden', '');
        return;
      }
      recentWrap.removeAttribute('hidden');
      recentList.innerHTML = list
        .map(function (term) {
          return (
            '<a class="z-chip" href="' + cfg.searchUrl + '?q=' + encodeURIComponent(term) + '">' + esc(term) + '</a>'
          );
        })
        .join('');
    }

    on($('[data-z-search-clear-recent]', panel), 'click', function () {
      try {
        localStorage.removeItem(RECENT_KEY);
      } catch (e) {}
      renderRecent();
    });

    /* ---------------- state ---------------- */
    var footbar = $('[data-z-search-footbar]', panel);
    var viewAllBtn = $('[data-z-search-viewall]', panel);
    var viewAllLabel = $('[data-z-search-viewall-label]', panel);

    function showIdle() {
      if (idle) idle.removeAttribute('hidden');
      if (live) {
        live.setAttribute('hidden', '');
        live.innerHTML = '';
      }
      if (loading) loading.setAttribute('hidden', '');
      if (footbar) footbar.setAttribute('hidden', '');
      activeIndex = -1;
    }

    function showLoading() {
      if (idle) idle.setAttribute('hidden', '');
      if (live) live.setAttribute('hidden', '');
      if (loading) loading.removeAttribute('hidden');
      if (footbar) footbar.setAttribute('hidden', '');
    }

    function showResults(html, query) {
      if (idle) idle.setAttribute('hidden', '');
      if (loading) loading.setAttribute('hidden', '');
      if (!live) return;
      live.innerHTML = html;
      live.removeAttribute('hidden');
      activeIndex = -1;

      if (footbar && query) {
        footbar.removeAttribute('hidden');
        if (viewAllBtn) viewAllBtn.setAttribute('href', cfg.searchUrl + '?q=' + encodeURIComponent(query));
        if (viewAllLabel) {
          viewAllLabel.textContent = (L.viewAll || 'View all results') + ' for \u2018' + query + '\u2019';
        }
      } else if (footbar) {
        footbar.setAttribute('hidden', '');
      }
    }

    /* ---------------- fetch ---------------- */
    function fetchSuggestions(query) {
      var key = query.toLowerCase();
      if (cache[key]) {
        render(query, cache[key]);
        return;
      }

      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var url =
        cfg.predictiveUrl +
        '?q=' +
        encodeURIComponent(query) +
        '&resources[type]=' +
        encodeURIComponent(cfg.resources || 'product,collection,article,page,query') +
        '&resources[limit]=' +
        (cfg.limit || 6) +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      showLoading();

      fetch(url, {
        signal: controller ? controller.signal : undefined,
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var payload = (data && data.resources && data.resources.results) || {};
          cache[key] = payload;
          render(query, payload);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          showResults(
            '<div></div><div class="z-search__empty"><strong>Search is taking a moment</strong>' +
              '<p>Press enter to see all results for &ldquo;' +
              esc(query) +
              '&rdquo;.</p></div>'
          );
        });
    }

    /* ---------------- render ---------------- */
    function highlight(text, query) {
      var safe = esc(text);
      query
        .trim()
        .split(/\s+/)
        .filter(function (t) {
          return t.length > 1;
        })
        .forEach(function (t) {
          var re = new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
          safe = safe.replace(re, '<mark>$1</mark>');
        });
      return safe;
    }

    function money(cents) {
      if (window.Zora && window.Zora.formatMoney) {
        window.ZoraTheme = window.ZoraTheme || {};
        window.ZoraTheme.moneyFormat = cfg.moneyFormat;
        return window.Zora.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function svgSearch() {
      return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.6-3.6"/></svg>';
    }
    function svgArrowUpRight() {
      return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7"/><path d="M8 7h9v9"/></svg>';
    }
    function svgArrowRight() {
      return '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16"/><path d="M14 6l6 6-6 6"/></svg>';
    }
    function svgBean() {
      return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><ellipse cx="12" cy="12" rx="6.2" ry="8.4" transform="rotate(35 12 12)"/><path d="M8.8 16.6c2.4-1 3.2-3.8 2.2-6.2-1-2.4-.2-5.2 2.2-6.2"/></svg>';
    }

    /* Predictive search returns price_min / price_max for variant ranges */
    function priceFor(p) {
      var min = p.price_min != null ? p.price_min : p.price;
      var max = p.price_max != null ? p.price_max : p.price;
      if (min == null) return '';
      min = typeof min === 'string' ? Math.round(parseFloat(min) * 100) : min;
      max = typeof max === 'string' ? Math.round(parseFloat(max) * 100) : max;
      if (isNaN(min)) return '';
      if (max != null && !isNaN(max) && max > min) return 'From ' + money(min);
      return money(min);
    }

    function render(query, res) {
      var products = res.products || [];
      var collections = res.collections || [];
      var articles = res.articles || [];
      var pages = res.pages || [];
      var queries = res.queries || [];

      var total = products.length + collections.length + articles.length + pages.length;
      var expanded = expandQuery(query);

      if (!total && !expanded.length && !queries.length) {
        showResults(
          '<div class="z-psearch__empty">' +
            '<strong>' + esc(L.empty || 'No matches for') + ' \u2018' + esc(query) + '\u2019</strong>' +
            '<p>' + esc(L.emptyHint || '') + '</p>' +
            '<p><a class="z-btn z-btn--sm" href="' + esc(L.emptyCtaUrl || '/collections/all') + '">' +
            esc(L.emptyCta || 'Shop all') + '</a></p>' +
          '</div>',
          null
        );
        return;
      }

      /* ---------- Left column ---------- */
      var aside = '';

      // Merchant synonyms first, then Shopify's completions, then product titles
      var suggestions = expanded
        .concat(
          queries.map(function (q) {
            return q.text;
          })
        )
        .filter(function (t, i, arr) {
          return t && arr.indexOf(t) === i;
        });

      if (!suggestions.length) {
        suggestions = products.slice(0, 4).map(function (p) {
          return p.title;
        });
      }

      if (suggestions.length) {
        aside +=
          '<p class="z-psearch__label">' +
          esc(L.suggested || 'Suggested searches') +
          '</p><ul class="z-psearch__suggestions">' +
          suggestions
            .slice(0, 5)
            .map(function (term) {
              return (
                '<li><a href="' +
                cfg.searchUrl +
                '?q=' +
                encodeURIComponent(term) +
                '" role="option">' +
                svgSearch() +
                '<span>' +
                highlight(term, query) +
                '</span>' +
                svgArrowUpRight() +
                '</a></li>'
              );
            })
            .join('') +
          '</ul>';
      }

      if (collections.length) {
        aside +=
          '<p class="z-psearch__label">' +
          esc(L.collections || 'Collections') +
          '</p><ul class="z-psearch__links">' +
          collections
            .slice(0, 5)
            .map(function (c) {
              return '<li><a href="' + c.url + '" role="option">' + highlight(c.title, query) + '</a></li>';
            })
            .join('') +
          '</ul>';
      }

      var reading = articles.concat(pages);
      if (reading.length) {
        aside +=
          '<p class="z-psearch__label">' +
          esc(L.reading || 'Reading & help') +
          '</p><ul class="z-psearch__links">' +
          reading
            .slice(0, 4)
            .map(function (a) {
              return '<li><a href="' + a.url + '" role="option">' + highlight(a.title, query) + '</a></li>';
            })
            .join('') +
          '</ul>';
      }

      /* ---------- Right column ---------- */
      var main = '';
      if (products.length) {
        main =
          '<div class="z-psearch__main-head">' +
          '<p class="z-psearch__label z-psearch__label--icon">' +
          svgBean() +
          esc(L.matches || 'Product matches') +
          '</p>' +
          '<a class="z-psearch__viewall" href="' +
          cfg.searchUrl +
          '?q=' +
          encodeURIComponent(query) +
          '">' +
          esc(L.viewAllShort || 'View all results') +
          svgArrowRight() +
          '</a></div><div class="z-psearch__grid">' +
          products
            .map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
              var sub = p.product_type || p.vendor || '';
              var price = priceFor(p);
              return (
                '<a class="z-psearch__card" href="' +
                p.url +
                '" role="option">' +
                '<span class="z-psearch__card-media">' +
                (img
                  ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" width="300" height="300">'
                  : '') +
                '</span><span class="z-psearch__card-body">' +
                '<span class="z-psearch__card-title">' +
                highlight(p.title, query) +
                '</span>' +
                (sub ? '<span class="z-psearch__card-sub">' + esc(sub) + '</span>' : '') +
                (price ? '<span class="z-psearch__card-price">' + price + '</span>' : '') +
                '</span></a>'
              );
            })
            .join('') +
          '</div>';
      } else {
        main =
          '<div class="z-psearch__empty">' +
          '<strong>' +
          esc(L.empty || 'No matches for') +
          ' \u2018' +
          esc(query) +
          '\u2019</strong><p>' +
          esc(L.emptyHint || '') +
          '</p></div>';
      }

      showResults(
        '<div class="z-psearch">' +
          '<div class="z-psearch__aside">' +
          aside +
          '</div><div class="z-psearch__main">' +
          main +
          '</div></div>',
        query
      );
    }

    /* ---------------- input wiring ---------------- */
    function handleInput(el) {
      return function () {
        if (el === input) syncGhost();
        if (!isOpen) openPanel(null);

        var q = el.value.trim();
        clearTimeout(debounceTimer);

        if (q.length < 2) {
          if (controller) controller.abort();
          showIdle();
          return;
        }

        debounceTimer = setTimeout(function () {
          fetchSuggestions(q);
        }, 220);
      };
    }

    if (input) on(input, 'input', handleInput(input));
    if (mobileInput) on(mobileInput, 'input', handleInput(mobileInput));

    on(form, 'submit', function () {
      pushRecent(input.value);
    });
    on(mobileForm, 'submit', function () {
      pushRecent(mobileInput.value);
    });

    /* ---------------- keyboard navigation ---------------- */
    function bindArrows(el) {
      on(el, 'keydown', function (e) {
        if (['ArrowDown', 'ArrowUp', 'Enter'].indexOf(e.key) === -1) return;

        var options = $$('[role="option"]', live).filter(function (a) {
          return a.offsetParent !== null;
        });
        if (!options.length) return;

        if (e.key === 'Enter') {
          if (activeIndex >= 0 && options[activeIndex]) {
            e.preventDefault();
            pushRecent(el.value);
            window.location.href = options[activeIndex].href;
          }
          return;
        }

        e.preventDefault();
        options.forEach(function (o) {
          o.removeAttribute('aria-selected');
          o.classList.remove('is-active');
        });

        activeIndex =
          e.key === 'ArrowDown'
            ? (activeIndex + 1) % options.length
            : (activeIndex - 1 + options.length) % options.length;

        var current = options[activeIndex];
        current.setAttribute('aria-selected', 'true');
        current.classList.add('is-active');
        current.scrollIntoView({ block: 'nearest' });
      });
    }

    if (input) bindArrows(input);
    if (mobileInput) bindArrows(mobileInput);

    syncGhost();
  })();
})();
